import { z } from 'zod';

export const EmailInsightInputSchema = z.object({
    'api-key': z.string(),
    account: z.string(),
    workspace: z.number({ coerce: true }),
    insight: z.string(),
});
